import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputInvalidBirthdateErrorMessage = (
  <Trans>
    Les premiers chiffres du numéro de registre national doivent représenter une date de naissance valide au format AA.MM.JJ
  </Trans>
);
